import VueRouter, { RouteConfig } from 'vue-router'

import IconMenuActive from '../assets/images/icon_menu_course_live_active@2x.png'
import IconMenuInactive from '../assets/images/icon_menu_course_live_inactive@2x.png'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'
import { DateWrapper } from 'kuaidong-lib'
const Layout = () => import('../views/Layout.vue')

const Details = () => import('../views/CourseLiveStatisticsDetails.vue')
const MineCourseDetail = () => import('../views/CourseLiveMineCourseDetail.vue')

const ListMine = () => import('../views/CourseLiveListMine.vue')
const ListResource = () => import('../views/CourseLiveListResource.vue')
const ListCourseResources = () => import('../views/live-courses/ListCourseResources.vue')
const CourseLiveDetail = () => import('../views/live-courses/LiveCourseResourcesDetail.vue')
const LiveCourseLessonSchedule = () => import('../views/live-courses/LiveCourseLessonSchedule.vue')
const LiveCourseLessonDetail = () => import('../views/live-courses/LiveCourseLessonDetail.vue')
const LiveCourseLessonStatistics = () => import('../views/live-courses/LiveCourseLessonStatistics.vue')
export const detailsRoute: RouteConfig = {
  path: 'details',
  name: 'course_live_details',
  component: Details,
  props: (route) => {
    return {
      ...route.query,
      ...route.params,
      currentDate: new DateWrapper(JSON.parse(route.query.currentDate as string)).date,
    }
  },
  meta: {
    title: '体育课程',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}
//
export const mineCourseDetailsRoute: RouteConfig = {
  path: 'mine-course-detail',
  name: 'mine_course_detail',
  component: MineCourseDetail,
  props: (route) => {
    return {
      ...route.query,
      ...route.params,
      currentDate: new DateWrapper(JSON.parse(route.query.currentDate as string)).date,
    }
  },
  meta: {
    title: '课程详情',
  },
}

export const listMineRoute: RouteConfig = {
  path: 'list-mine',
  name: 'course_live_list_mine',
  component: ListMine,
  props: (route) => {
    return {
      ...route.query,
      ...route.params,
    }
  },
  meta: {
    title: '体育课程',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const listResourceRoute: RouteConfig = {
  path: 'list-resource-old',
  name: 'course_live_list_resource_old',
  component: ListResource,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程资源库',
  },
}
export const ListCourseResourcesRoute: RouteConfig = {
  path: 'list-resource',
  name: 'course_live_list_resource',
  component: ListCourseResources,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程资源库',
    showMenu: true,
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}
export const CourseResourceDetailRoute: RouteConfig = {
  path: 'course-resource-detail',
  name: 'course_resource_detail',
  component: CourseLiveDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体育课程',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const LiveCourseLessonScheduleRoute: RouteConfig = {
  path: 'live-course-time-table',
  name: 'live_course_time_table',
  component: LiveCourseLessonSchedule,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程表',
    showMenu: true,
  },
}
export const LiveCourseLessonDetailRoute: RouteConfig = {
  path: 'live-course-lesson-detail',
  name: 'live-course-lesson-detail',
  component: LiveCourseLessonDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程表',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const LiveCourseLessonStatisticsRoute: RouteConfig = {
  path: 'live-course-lesson-statistics',
  name: 'live_course_lesson_statistics',
  component: LiveCourseLessonStatistics,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程表',
  },
}

export default [
  {
    path: '/course-live',
    name: 'course_live',
    component: Layout,

    meta: {
      title: '在线体育课',
      icon: IconMenuInactive,
      iconActive: IconMenuActive,
      showMenu: true,
    },
    children: [
      ListCourseResourcesRoute,
      CourseResourceDetailRoute,
      LiveCourseLessonScheduleRoute,
      detailsRoute,
      mineCourseDetailsRoute,
      listMineRoute,
      listResourceRoute,
      LiveCourseLessonDetailRoute,
      LiveCourseLessonStatisticsRoute,
    ],
  },
]

export function navigateToLiveCourseDetails(router: VueRouter, id: string, currentDate: Date) {
  router.push({ name: detailsRoute.name, query: { id, currentDate: JSON.stringify(currentDate) } })
}
export function navigateToLiveCourseRepoDetails(router: VueRouter, id: string) {
  router.push({ name: CourseResourceDetailRoute.name, query: { id } })
}

export function navigateToLiveCourseLessonDetail(
  router: VueRouter,
  id: string,
  from?: string,
  homeworkTemplateId?: string
) {
  router.push({ name: LiveCourseLessonDetailRoute.name, query: { id, from, homeworkTemplateId } })
}

export function navigateToLiveCourseLessonStatistics(router: VueRouter, id: string) {
  router.push({ name: LiveCourseLessonStatisticsRoute.name, query: { id } })
}

export function navigateToLiveCourseTimeTable(router: VueRouter) {
  router.push({ name: LiveCourseLessonScheduleRoute.name })
}
